import { render } from "./horizontal-sidebar.vue?vue&type=template&id=0ef941f9&scoped=true"
import script from "./horizontal-sidebar.vue?vue&type=script&lang=js"
export * from "./horizontal-sidebar.vue?vue&type=script&lang=js"

import "./horizontal-sidebar.vue?vue&type=style&index=0&id=0ef941f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef941f9"]])

export default __exports__